
//公共目录 项目价格 接口相关的函数
import request from "../../untils/request.js"

/**
 *
 *  post
 *
 */
//往来单位分页
export const getContractDeptList = (params) => {
    return request.get("/outpatient/contunt/page", {params} )
}

export default{

}